<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="bd-form" v-html="form">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'GetOnBoard',
        data() {
            return {
                form: '',
                loading: true,
                errorText: '',
                urlFieldValue: ''
            }
        },
        mounted() {
            // console.log(this.$route)
            let url = ''
            if(this.$route.query.hasOwnProperty('record')) {
                url = `${this.$store.state.client_vars.GETONBOARDEDIT}?record=${this.$route.query.record}`
            } else {
                url = `${this.$store.state.client_vars.GETONBOARD}`
            }
            // let url = `${this.$store.state.client_vars.GETONBOARD}${this.$route}`

            this.$axios({
                url: url,
                responseType: 'document'
            })
            .then(response => {
                this.form = response.data.body.innerHTML
                this.loading = false;
                this.setInterval()
            })
            .then(() => {
                let js = document.querySelectorAll('form script');
                for(let i = 0; i < js.length; i++) {
                    eval(js[i].text)
                }

                let allInputsOnLoad = document.querySelectorAll('.input__valid input'),
                    urlFieldOnLoad = allInputsOnLoad[3];

                // urlFieldOnLoad.value = this.fixWebsiteURL(urlFieldOnLoad.value);
            })
            .catch(error => console.log('Failed to return form', error))  
        },
        methods: {
            bindToLogin: () => {
                let submit = document.querySelector('#SQ_LOGIN_SUBMIT');
                let pwd = document.querySelector('#SQ_LOGIN_PASSWORD');
                let user = document.querySelector('#SQ_LOGIN_USERNAME');

                if(submit && pwd && user) {
                    pwd.addEventListener('keydown', (e) => {
                        if(e.keyCode === 13 || e.key === "Enter") {
                            submit.click();
                        }
                    })

                    user.addEventListener('keydown', (e) => {
                        if(e.keyCode === 13 || e.key === "Enter") {
                            submit.click();
                        }
                    })
                }
            },
            setInterval: function() {
                // wait for form to appear before binding events to it
                let interval = window.setInterval(() => {
                    if(document.querySelector('form')) {
                        clearInterval(interval)
                        this.bindToLogin();
                        this.bindForm(this.form)
                        // Set maxlenfgth on description field
                        let bdDescription = document.querySelector('.bd-form__description').getElementsByTagName('textarea')[0];
                        if(bdDescription) { 
                            bdDescription.setAttribute('maxlength', 250);
                        }
                        let radioInputs = document.querySelectorAll('input[type=radio]');

                        for(let input of radioInputs){
                            if(input.value == 'true') {
                                input.parentElement.parentElement.nextSibling.nextSibling.style.display = 'block';
                            } else {
                                input.parentElement.parentElement.nextSibling.nextSibling.style.display = 'none';
                            }
                            
                            input.addEventListener('change', function(e) {
                                var nextSibling = e.target.parentElement.parentElement.nextSibling.nextSibling;
                                if(e.target.value == 'true' ) {
                                    nextSibling.style.display = 'block';
                                } else {
                                    nextSibling.style.display = 'none';
                                }
                            })
                        }
                    } else {
                        console.log('finding....')
                    }
                }, 1000)
            },
            bindForm: function(form) {
                document.querySelector('form').addEventListener('submit', (e) => {
                    e.preventDefault();
                    if(window.formType === 'CreateForm') {
                        this.validateForm(e.target)
                    } else {
                        this.postForm(e.target)
                    }
                })
            },
            postForm: function(form) {
                this.form = "Loading"
                let url = form.getAttribute('action');

                if(window.formType === "CreateForm") {
                    this.urlFieldValue = document.querySelectorAll('.input__valid input')[3].value
                }

                this.$axios({
                    method: 'post',
                    url: url,
                    data: new FormData(event.target),
                    responseType: 'document'
                    // headers: {'Content-Type': 'multipart/form-data' },
                })
                .then((response) => {
                    this.form = response.data.body.innerHTML
                    this.setInterval()
                    this.$axios.get(this.$store.state.client_vars.MENU)
                    .then(response => {
                        this.$store.commit('addMenu', response.data)
                        if(window.formType === "CreateForm") {
                            document.querySelectorAll('.input__valid input')[3].value = this.urlFieldValue
                        }
                    })
                    .catch(error => console.log('Failed to get menu', error))
                })
                .then(() => {
                    let js = document.querySelectorAll('form script');
                    for(let i = 0; i < js.length; i++) {
                        eval(js[i].text)
                    }
                })
                event.preventDefault();
            },
            appendError: function(field, message) {
                var newEl = document.createElement('div');
                newEl.innerHTML = `<p class="appendedError" style="color:red;">${message}</p>`;
                field.parentNode.insertBefore(newEl, field.nextSibling);
            },
            validateForm: function(form) {
                let errorMessages = document.querySelectorAll('.appendedError');

                for(let i = 0; i < errorMessages.length; i++) {
                    errorMessages[i].remove()
                }

                let radioInputs = document.querySelectorAll('input[type=radio]');
                let allValidInputs = document.querySelectorAll('.input__valid input');

                let emailField = allValidInputs[0],
                    urlField = allValidInputs[3],
                    phone = allValidInputs[1],
                    postCode = allValidInputs[2];
                
                let emailReg = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
                    urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/,
                    postCodeReg = /^[0-9]*$/,
                    numberReg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
                
                let error = false
    
                // urlField.value = this.fixWebsiteURL(urlField.value);
        
                for(let input of radioInputs){
                    if(input.value == 'true') {
                        input.parentElement.parentElement.nextSibling.nextSibling.style.display = 'block';
                    } else {
                        input.parentElement.parentElement.nextSibling.nextSibling.style.display = 'none';
                    }
                    
                    input.addEventListener('change', function(e) {
                        console.log('logging name', e.target.name);
                        var nextSibling = e.target.parentElement.parentElement.nextSibling.nextSibling;
                        console.log(e.target.parentElement.parentElement.nextSibling.nextSibling)
                        if(e.target.value == 'true' ) {
                            nextSibling.style.display = 'block';
                        } else {
                            nextSibling.style.display = 'none';
                        }
                    })
                }
                    
                if(!emailReg.test(emailField.value) && emailField.value.length > 0) {
                    error = true;
                    this.appendError(emailField, 'The email field is incorrect. Please make sure this is a valid email address');
                }
                    
                if(!urlReg.test(urlField.value) && urlField.value.length > 0) {
                    error = true;
                    this.appendError(urlField, 'The website/social media field is incorrect. Please make sure this is a valid URL with http:// or https:// prepended. For example: https://google.co.nz"');
                }
                
                if(!postCodeReg.test(postCode.value) && postCode.value.length > 0) {
                    error = true;
                    this.appendError(postCode, 'The post code is not correct. Please make sure this is a valid post code number with no special characters.');
                }
                
                if(!numberReg.test(phone.value) && phone.value.length > 0) {
                    error = true;
                    this.appendError(phone, 'The phone field is incorrect. Please make sure this is a valid phone number with no special characters.');
                }
                
                if(error) {
                    return false
                } else {
                    this.postForm(form)
                }
            },
            // fixWebsiteURL: function(url) {
            //     let fixURL = url;
            //     fixURL.replace(!/^https?:/i, '');

            //     if (!/^https?:\/\//i.test(fixURL)) {
            //         fixURL = 'https://' + fixURL;
            //     } else {
            //         fixURL = '';
            //     }

            //     return fixURL;
            // }
        }
    }
</script>

<style lang="scss">
  .bd-form {
    margin-bottom: 60px;
  }
  
  .bd-form h2 {
    font-family: OpenSans;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #0080c5;
    margin-bottom: 15px;
  }
  
  .bd-form fieldset {
    border: 0;
  }
  
  .bd-form legend {
    display: inline-block;
    width: 100%;
    padding-bottom: 22px;
    color: #838383;
    text-transform: uppercase;
    border-bottom: 1px solid #ccc;
    font-size: 14px;
  }
  
  .bd-form label {
    color: #53565a;
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 5px;
    display: block;
  }
  
  .bd-form input, select, textarea {
    min-height: 36px;
    background-color: #fbfbfb!important;
    border: 1px solid #ddd!important;
    border-radius: 3px;
    width: 100%;
    padding: 9px 14px;
    font-size: 14px;
  }
  
  .bd-form input[type="radio"] {
    width: auto;
    margin-right: 10px;
  }
  
  .bd-form input[type="radio"] + label {
    width: auto;
    display: inline !important;
    margin: 0;
  }
  
  .bd-form input[type="submit"], .bd-form input[type="button"] {
    box-shadow: none;
    border-radius: 10px;
    border: 2px solid #ccc!important;
    color: #0080c5!important;
    background-color: #fff!important;
    transition: all .2s ease-in-out;
    text-transform: capitalize;
    height: 50px!important;
    width: auto;
    float: right;
    min-width: 64px;
    padding: 0 27px;
    font-size: 16px;
  }
  
  .bd-form input[type="submit"]:hover, .bd-form input[type="button"]:hover  {
    border-color: #0080c5!important;
    background-color: #0080c5!important;
    color: #fff!important;
  }
  
  .bd-form select {
    background: url(/__data/assets/file/0011/2153/chevron-down.svg) no-repeat right #fbfbfb;
    background-position: right 10px top 16px;
    -webkit-appearance: none;
  }
  
  
  .bd-form .bd-form-submit {
    padding-top: 30px;
    margin-top: 30px;
    border-top: 1px solid #ccc;
  }
  
  .bd-form-submit {
    display: inline-block;
    width: 100%;
    clear: both;
  }
  
  .bd-form ul li {
    padding: 0 !important;
    background: none !important;
  }
  
  .bd-form .bd-form-errors {
    color: #cd3232;
  }
  
  .bd-form .bd-form-errors li {
    display: block !important;
  }
  
  .bd-form__captcha {
    justify-content:flex-end;
    display: flex;
  }
</style>